import { createStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const styles = (theme: Theme) => createStyles({
  root: {
    width: '100%',
  },
  formControl: {
    marginRight: theme.spacing(2),
    width: '100%',
  },
  description: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(2),
  },
});

export default styles;
